import axios from '../http'
import {API} from "../const"

const api = API;
const regionApi = API+'/regions/tree';

const error = (name) => (e) => console.error(name + ':=>', e);

export function regionList(cb, fcb = error('regionList')) {
    axios.get(regionApi).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}

export function upload(data, cb, fcb = error('upload')) {
    axios.post(api+'/upload', data).then(d => {
        cb(d.data);
    }).catch(d => fcb(d));
}


export function addStoreRegistered(params, cb, fcb = error('addStoreRegistered')) {
    axios.post(api+'/store-registered', params).then(d => {
        cb(d);
    }).catch(d => fcb(d));
}

export function findByPhone(phone, cb, fcb = error('findByPhone')) {
    axios.get(api+"/store-registered", {params:{phone}}).then(response => {
        cb(response.data);
    }).catch(err => {
        fcb(err);
    })
}
